export default "__VITE_ASSET__CzfWh73R__"